export default __webpack_public_path__ + "locales/sr-Latn-RS/DeleteProfileEverDialog.json?hash=e9c0d460cf647815525baa0748df27a8";